import React from 'react';
import styles from './ActivityHeader.module.scss';
import { useNavigate } from 'react-router-dom';

const EventsActivityHeader = ({
  selectedActivity,
  setSelectedActivity,
  eventType,
}) => {
  const navigate = useNavigate();

  return (
    <div className={styles['row']}>
      <div className={styles['container']}>
        <div>
          <span
            className={
              'event' === eventType ? styles['active'] : styles['in-active']
            }
            // onClick={() => setEventsType("events")}
            onClick={() => navigate('/home/events/event')}
          >
            الفعاليات
          </span>
        </div>
        <div>
          <span
            className={
              'event-countdown' === eventType
                ? styles['active']
                : styles['in-active']
            }
            // onClick={() => setEventsType("events-countdown")}
            onClick={() => navigate('/home/events/event-countdown')}
          >
            عد تنازلي للفعاليات
          </span>
        </div>
      </div>
      {'event' === eventType && (
        <div className={styles['container']}>
          <div>
            <span
              className={
                null === selectedActivity
                  ? styles['active']
                  : styles['in-active']
              }
              onClick={() => setSelectedActivity(null)}
            >
              الكل
            </span>
          </div>
          <div>
            <span
              className={
                true === selectedActivity
                  ? styles['active']
                  : styles['in-active']
              }
              onClick={() => setSelectedActivity(true)}
            >
              فعال
            </span>
          </div>
          <div>
            <span
              className={
                false === selectedActivity
                  ? styles['active']
                  : styles['in-active']
              }
              onClick={() => setSelectedActivity(false)}
            >
              غير فعال
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default EventsActivityHeader;
